module.exports = __webpack_public_path__ + "static/media/logo_MONEY.10467d34.svg";